"use client";
import { useSearchParams } from "next/navigation";
import { useJourneySession } from "@/hooks/useJourneySession";

// Consume legacy-link resets even on a landing page without a lookup form.
export function JourneySession() {
	const params = useSearchParams();
	useJourneySession(params.get("restart") === "1");
	return null;
}
